/* src/app/modules/investment/amortisation/table-dialog.component.scss */
:host {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  min-width: 0;
}
.at-header-text {
  min-width: 0;
  padding-right: 32px;
}
.at-kpis {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  margin-bottom: 14px;
}
.at-kpi {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 8px 10px;
  background: #f4f6f8;
  border-radius: 8px;
  min-width: 0;
}
.at-kpi--accent {
  background: #fbfee8;
  border: 1px solid #e5f3a0;
}
.at-kpi__label {
  font-size: 11px;
  color: #6b7280;
}
.at-kpi__value {
  font-size: 15px;
  font-weight: 700;
  color: #1a1d23;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.at-alert {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 14px;
  margin-bottom: 12px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 13px;
  color: #4b5563;
}
.at-alert mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  color: #6b7280;
}
.at-alert--error {
  background: #fef2f2;
  border-color: #fecaca;
  color: #991b1b;
}
.at-alert--error mat-icon {
  color: #dc2626;
}
.at-table-wrap {
  border: 1px solid #eef1f4;
  border-radius: 8px;
  overflow: auto;
}
.at-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.at-table th {
  position: sticky;
  top: 0;
  background: #f4f6f8;
  color: #6b7280;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  text-align: left;
  padding: 8px 12px;
}
.at-table td {
  padding: 6px 12px;
  color: #2f3540;
  border-top: 1px solid #eef1f4;
}
.at-year td {
  background: #f9fafb;
  font-weight: 700;
  color: #1a1d23;
}
.at-current .at-year td {
  background: #fbfee8;
}
.at-num {
  text-align: right !important;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
@media (max-width: 600px) {
  .at-kpis {
    grid-template-columns: 1fr;
  }
}
/*# sourceMappingURL=table-dialog.component.css.map */
